import script from "./UserBookings.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBookings.vue?vue&type=script&setup=true&lang=js"

import "./UserBookings.vue?vue&type=style&index=0&id=0f2dc550&lang=css"

const __exports__ = script;

export default __exports__